export function isColorDark(color) {
     // 将颜色转换为RGB值
     const r = parseInt(color.substring(1, 3), 16);
     const g = parseInt(color.substring(3, 5), 16);
     const b = parseInt(color.substring(5, 7), 16);
     // 计算亮度（亮度 = 0.299R + 0.587G + 0.114B）
     const brightness = (r * 0.299 + g * 0.587 + b * 0.114) / 255;
     // 根据亮度返回是否为深色（这里可以设定一个阈值，例如0.5）
     return brightness < 0.5;
  }


  export function checkClient() {
      // 获取 User Agent
      var userAgent = navigator.userAgent.toLowerCase();
      if (/(zonglan6756)/i.test(userAgent)) {
         return 'zl';
      } else if(/(hbxw)/i.test(userAgent)) {
         return 'hbrb';
      } else if (userAgent.indexOf('micromessenger') !== -1) {
         return 'wx';
      } else {
         return 'h5';
      }
   }  